module.exports = __webpack_public_path__ + "Flag-580.df6c7dbafd8ef0c33e294143c29effa9.svg";